import React from 'react';
import MainLayout from '../components/Layout/MainLayout.js';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card.jsx';
import { FileText, Download, BarChart3, Users, Shield, DollarSign } from 'lucide-react';
import { Button } from '../components/ui/button.jsx';

const REPORTS = [
  { id: 1, title: 'Relatório ESG Completo', desc: 'Scores ambientais, sociais e de governança com benchmark setorial', icon: Shield, category: 'ESG', date: '2024' },
  { id: 2, title: 'Pesquisa Salarial por Cargo', desc: 'Análise de remuneração com quartis P25/P50/P75 por função', icon: DollarSign, category: 'Remuneração', date: '2024' },
  { id: 3, title: 'Indicadores de RH', desc: 'Turnover, absenteísmo, PCD e métricas de recrutamento', icon: Users, category: 'RH', date: '2024' },
  { id: 4, title: 'Benchmark Institucional', desc: 'Comparativo entre empresas participantes por segmento e porte', icon: BarChart3, category: 'Benchmark', date: '2024' },
  { id: 5, title: 'Análise de Benefícios', desc: 'Comparativo de pacotes de benefícios por setor e porte', icon: FileText, category: 'Benefícios', date: '2024' },
];

const Relatorios = () => {
  const userRole = localStorage.getItem('userRole') || 'respondent';

  return (
    <MainLayout title="Relatórios" userRole={userRole}>
      <div className="space-y-6" data-testid="relatorios-page">
        <p className="text-sm text-slate-500">Gere e baixe relatórios analíticos em PDF. Funcionalidade de exportação será habilitada em breve.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {REPORTS.map(report => {
            const Icon = report.icon;
            return (
              <Card key={report.id} className="hover:shadow-md transition-shadow" data-testid={`report-card-${report.id}`}>
                <CardContent className="p-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                      <Icon className="w-5 h-5 text-blue-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between gap-2">
                        <div>
                          <h3 className="font-semibold text-slate-900 text-sm">{report.title}</h3>
                          <p className="text-xs text-slate-500 mt-0.5">{report.desc}</p>
                        </div>
                        <span className="text-xs bg-slate-100 text-slate-500 px-2 py-0.5 rounded shrink-0">{report.category}</span>
                      </div>
                      <div className="flex items-center justify-between mt-3">
                        <span className="text-xs text-slate-400">Período: {report.date}</span>
                        <Button variant="outline" size="sm" className="h-8 text-xs gap-1.5" disabled data-testid={`download-report-${report.id}`}>
                          <Download className="w-3.5 h-3.5" />
                          PDF (em breve)
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
};

export default Relatorios;
